export default "__VITE_ASSET__494fd2ce__"